module.exports = __webpack_public_path__ + "static/Video30añosEn-ad9a08c2d1f559f250e3feb827466e4d.mp4";